
// FUNCTION TO CONTROL DROPDOWNS ONLY IN NAVBAR MENUS
export function showNavbarDropdown(dropdownSelector, contentSelector) {
  const dropdowns = document.querySelectorAll(dropdownSelector);
  const contents = document.querySelectorAll(contentSelector);

  // Loop through each dropdown element
  dropdowns.forEach((dropdown, index) => {
    const dropdownIcon = dropdown.querySelector('i');

    dropdown.addEventListener('click', () => {
      dropdownIcon.classList.toggle('rotate-element');
      contents[index].classList.toggle('d-flex');

      setTimeout(() => {
        contents[index].classList.add('dropdown-active');
      }, 100);
    });

    document.addEventListener('click', (event) => {
      if (contents[index].classList.contains('dropdown-active')) {
        let isClickInside = contents[index].contains(event.target);

        if (!isClickInside) {
          dropdownIcon.classList.remove('rotate-element');
          contents[index].classList.remove('d-flex');

          setTimeout(() => {
            contents[index].classList.remove('dropdown-active');
          }, 100);
        }
      }
    });
  });
}


// FUNCTION TO CONTROL DROPDOWNS ONLY IN SIDEBARS
export function showSidebarDropdown(dropSidebar, contentSidebar, indexSidebar) {
  const dropdownSelected = document.querySelector(dropSidebar);
  const contentSelected = document.querySelectorAll(contentSidebar);

  if(dropdownSelected) {
    const dropdownIcon = dropdownSelected.querySelector('i');

    dropdownSelected.addEventListener('click', () => {
      dropdownIcon.classList.toggle('rotate-element');
      contentSelected[indexSidebar].classList.toggle('d-flex');

      if(contentSelected[indexSidebar].classList.contains('d-flex')) {
        const dropdownHeight = contentSelected[indexSidebar].offsetHeight;

        dropdownSelected.style.cssText = `margin-bottom: calc(${dropdownHeight}px + 10px);`;
      } else {
        dropdownSelected.style.removeProperty('margin-bottom');
      }
    });
  }
}
